/*!

=========================================================
* Black Dashboard PRO React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/black-dashboard-pro-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
import { Route, Switch, Redirect } from "react-router-dom";

// reactstrap components
import {
  Button,
  ButtonGroup,
  Card,
  CardImg,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  CardText,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  Row,
  Col
} from "reactstrap";

// core components
import {
  chartExample1,
  chartExample2,
  chartExample3,
  chartExample4
} from "variables/charts.js";
import logo from 'assets/img/analytics.jpeg'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { 
  fetchGetModels, 
  fetchGetDataModel, 
  fetchGetStatsModel, 
  fetchGetTrendModel
} from "../actions/model_actions";

var mapData = {
  AU: 760,
  BR: 550,
  CA: 120,
  DE: 1300,
  FR: 540,
  GB: 690,
  GE: 200,
  IN: 200,
  RO: 600,
  RU: 300,
  US: 2920
};

class Models extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      bigChartData: "data1",
      models: [],
      redirectToLogin: false,
      showModelInfo: false,
      modelInfo: {},
      model_id: "",
      width: 0
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  componentDidMount() {
    const { fetchGetModels } = this.props;
    // const idToken_test = localStorage.getItem('idToken');
    const idToken = document.cookie.replace(/(?:(?:^|.*;\s*)idToken\s*\=\s*([^;]*).*$)|^.*$/, "$1");
    fetchGetModels(idToken);
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  componentDidUpdate(prevProps, prevState) {
    const { model, user, fetchGetPingModel } = this.props;
    if(model.user_models !== prevProps.model.user_models) {
      this.setState({models: model.user_models});
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth });
  }

  setBgChartData = name => {
    this.setState({
      bigChartData: name
    });
  };

  info = (info) => {
    const { user } = this.props;
    // console.log(info)
    let idToken = document.cookie.replace(/(?:(?:^|.*;\s*)idToken\s*\=\s*([^;]*).*$)|^.*$/, "$1");
    this.setState({showModelInfo: true, modelInfo: info, model_id: info.model_id});
    localStorage.setItem("model_id", info.model_id);
    localStorage.setItem("user_id", user.user_logged.user_id);
    // fetchGetDataModel(idToken, info.model_id);
    // fetchGetStatsModel(idToken, info.model_id);
    // fetchGetTrendModel(idToken, info.model_id);
  }

  render() {
    const { models, showModelInfo, width, model_id } = this.state;
    const { user } = this.props;
    // console.log(user);
    if(showModelInfo) {
      return <Redirect to={{
        pathname: "/user/dashboard",
        state: {model_id, user}
      }} />
    }

    return (
      <>
        <div className="content" >
          <Row>
            <Col xs="12">
              {models && models.length !== 0 ?
                <Card className="card-plain">
                  <CardHeader>
                    <Row>
                      <Col className="text-left" sm="6">
                        <CardTitle tag="h2">My Models</CardTitle>
                      </Col>
                    </Row>
                  </CardHeader>
                  <CardBody>
                    <Row>
                      {models && models.map((val, index) =>{
                        let date_added = new Date(val.created_at);
                        let updated_added = null; 
                        // console.log(val.versioning)
                        let long = val.versioning.length;
                        if(val && val.versioning && val.versioning[long - 1] && val.versioning[long - 1].version_date) {
                          updated_added = new Date(val.versioning[long - 1].version_date);
                        }
                        return (
                            <Col sm="12" md="6" lg="4" xl={width <= 1900 ? "3" : width > 1900 && width < 3000 ? "2" : "1"} key={index}>
                              <Card style={{margin: "2% 1%", maxWidth: '19rem', cursor: "pointer"}} key={index} onClick={this.info.bind(this, val)}>
                                <CardImg top src={logo} alt="..."/>
                                <CardBody>
                                  <CardTitle tag="h2">{val.model_name}</CardTitle>
                                  <CardText tag="h4">{val.description}</CardText>
                                  <br/>
                                  <CardText tag="h6">Created at</CardText>
                                  <CardText tag="h5">{date_added.toISOString().split('T')[0]}</CardText>
                                  <CardText tag="h6">Latest Version</CardText>
                                  {val && val.versioning && val.versioning[long - 1] && val.versioning[long - 1].version_name && updated_added ?
                                    <CardText tag="h5">{val.versioning[long - 1].version_name + "@" + updated_added.toISOString().split('T')[0]}</CardText> : 
                                    <CardText tag="h5">This model doesn't have any version</CardText>
                                  }
                                  
                                </CardBody>
                              </Card>
                            </Col>
                        )
                      })}
                    </Row>
                  </CardBody>
                </Card> : 
                <h4>
                  YOU DON'T HAVE ANY MODELS
                </h4>
              }
            </Col>
          </Row>
        </div>
      </>
    );
  }
}

function mapStateToProps({model, auth, user}){
  return{
      model,
      auth,
      user
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators(
      { 
        fetchGetModels, 
        fetchGetDataModel, 
        fetchGetStatsModel, 
        fetchGetTrendModel 
      }, dispatch
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(Models);
/* <Col lg="3" md="6">
              <Card className="card-stats">
                <CardBody>
                  <Row>
                    <Col xs="5">
                      <div className="info-icon text-center icon-warning">
                        <i className="tim-icons icon-chat-33" />
                      </div>
                    </Col>
                    <Col xs="7">
                      <div className="numbers">
                        <p className="card-category">Number</p>
                        <CardTitle tag="h3">150GB</CardTitle>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
                <CardFooter>
                  <hr />
                  <div className="stats">
                    <i className="tim-icons icon-refresh-01" /> Update Now
                  </div>
                </CardFooter>
              </Card>
            </Col>
            <Col lg="3" md="6">
              <Card className="card-stats">
                <CardBody>
                  <Row>
                    <Col xs="5">
                      <div className="info-icon text-center icon-primary">
                        <i className="tim-icons icon-shape-star" />
                      </div>
                    </Col>
                    <Col xs="7">
                      <div className="numbers">
                        <p className="card-category">Followers</p>
                        <CardTitle tag="h3">+45k</CardTitle>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
                <CardFooter>
                  <hr />
                  <div className="stats">
                    <i className="tim-icons icon-sound-wave" /> Last Research
                  </div>
                </CardFooter>
              </Card>
            </Col>
            <Col lg="3" md="6">
              <Card className="card-stats">
                <CardBody>
                  <Row>
                    <Col xs="5">
                      <div className="info-icon text-center icon-success">
                        <i className="tim-icons icon-single-02" />
                      </div>
                    </Col>
                    <Col xs="7">
                      <div className="numbers">
                        <p className="card-category">Users</p>
                        <CardTitle tag="h3">150,000</CardTitle>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
                <CardFooter>
                  <hr />
                  <div className="stats">
                    <i className="tim-icons icon-trophy" /> Customers feedback
                  </div>
                </CardFooter>
              </Card>
            </Col>
            <Col lg="3" md="6">
              <Card className="card-stats">
                <CardBody>
                  <Row>
                    <Col xs="5">
                      <div className="info-icon text-center icon-danger">
                        <i className="tim-icons icon-molecule-40" />
                      </div>
                    </Col>
                    <Col xs="7">
                      <div className="numbers">
                        <p className="card-category">Errors</p>
                        <CardTitle tag="h3">12</CardTitle>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
                <CardFooter>
                  <hr />
                  <div className="stats">
                    <i className="tim-icons icon-watch-time" /> In the last
                    hours
                  </div>
                </CardFooter>
              </Card>
            </Col> */
            /* <Col lg="4">
              <Card className="card-chart">
                <CardHeader>
                  <h5 className="card-category">Total Shipments</h5>
                  <CardTitle tag="h3">
                    <i className="tim-icons icon-bell-55 text-primary" />{" "}
                    763,215
                  </CardTitle>
                </CardHeader>
                <CardBody>
                  <div className="chart-area">
                    <Line
                      data={chartExample2.data}
                      options={chartExample2.options}
                    />
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col lg="4">
              <Card className="card-chart">
                <CardHeader>
                  <h5 className="card-category">Daily Sales</h5>
                  <CardTitle tag="h3">
                    <i className="tim-icons icon-delivery-fast text-info" />{" "}
                    3,500€
                  </CardTitle>
                </CardHeader>
                <CardBody>
                  <div className="chart-area">
                    <Bar
                      data={chartExample3.data}
                      options={chartExample3.options}
                    />
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col lg="4">
              <Card className="card-chart">
                <CardHeader>
                  <h5 className="card-category">Completed Tasks</h5>
                  <CardTitle tag="h3">
                    <i className="tim-icons icon-send text-success" /> 12,100K
                  </CardTitle>
                </CardHeader>
                <CardBody>
                  <div className="chart-area">
                    <Line
                      data={chartExample4.data}
                      options={chartExample4.options}
                    />
                  </div>
                </CardBody>
              </Card>
            </Col> */
/* <Col sm="6">
                      <ButtonGroup
                        className="btn-group-toggle float-right"
                        data-toggle="buttons"
                      >
                        <Button
                          color="info"
                          id="0"
                          size="sm"
                          tag="label"
                          className={classNames("btn-simple", {
                            active: this.state.bigChartData === "data1"
                          })}
                          onClick={() => this.setBgChartData("data1")}
                        >
                          <input defaultChecked name="options" type="radio" />
                          <span className="d-none d-sm-block d-md-block d-lg-block d-xl-block">
                            Accounts
                          </span>
                          <span className="d-block d-sm-none">
                            <i className="tim-icons icon-single-02" />
                          </span>
                        </Button>
                        <Button
                          color="info"
                          id="1"
                          size="sm"
                          tag="label"
                          className={classNames("btn-simple", {
                            active: this.state.bigChartData === "data2"
                          })}
                          onClick={() => this.setBgChartData("data2")}
                        >
                          <input name="options" type="radio" />
                          <span className="d-none d-sm-block d-md-block d-lg-block d-xl-block">
                            Purchases
                          </span>
                          <span className="d-block d-sm-none">
                            <i className="tim-icons icon-gift-2" />
                          </span>
                        </Button>
                        <Button
                          color="info"
                          id="2"
                          size="sm"
                          tag="label"
                          className={classNames("btn-simple", {
                            active: this.state.bigChartData === "data3"
                          })}
                          onClick={() => this.setBgChartData("data3")}
                        >
                          <input name="options" type="radio" />
                          <span className="d-none d-sm-block d-md-block d-lg-block d-xl-block">
                            Sessions
                          </span>
                          <span className="d-block d-sm-none">
                            <i className="tim-icons icon-tap-02" />
                          </span>
                        </Button>
                      </ButtonGroup>
                    </Col> */